import React, { useState } from "react"
import PropTypes from "prop-types"

import Typograph from "../../../../components/Typograph"
import OrderInfo from "./OrderInfo"
import Link from "shared/components/Link"

import styles from "./styles.css"

import { TYPE_OF_SALE } from "../NewSale/constants"

import iconSuccess from "../../../../assets/svg/fixed-voice-success.svg"
import iconCopy from "../../../../assets/svg/fixed-voice-copy-paste.svg"
import iconArrowRight from "../../../../assets/svg/fixed_voice_arrow_right.svg"

const OrderStatus = ({
  infoSuspension,
  category,
  quantityOfNumbers,
  assigneeName,
  isPortability,
  isSpecialistAnalyst,
  requestId,
  protocolo
}) => {
  const [isCopied, setIsCopied] = useState(false)

  const receivedOrderText = isSpecialistAnalyst
    ? "Agora é só aguardar, sua solicitação já está com um especialista da Algar"
    : "Seu pedido foi recebido e já está em andamento!"

  const typeOfSales = isPortability
    ? TYPE_OF_SALE.PORTABILITY.TITLE.toLowerCase()
    : TYPE_OF_SALE.NEW_SALE.TITLE.toLowerCase()

  const description = isSpecialistAnalyst
    ? `Você solicitou ${category.toLowerCase()} e um especialista da Algar cuidará deste caso, dentro de 24 horas úteis receberá os alertas do andamento do meio de comunicação informado por você`
    : `Você solicitou ${quantityOfNumbers} número(s) para ${assigneeName} em uma ${typeOfSales}. Seu pedido ficará em andamento até que seja concluído nas próximas 24 horas úteis.`

  const infoSuspensionText =
    " Conforme as regras de portabilidade, a suspensão é válida por 30 dias. Após este período a portabilidade será cancelada automaticamente pela EA."

  const protocolText = `O(s) número(s) de protocolo desta ${typeOfSales} estão sendo processado(s). Você poderá visualizá-lo(s) na página do cliente mais tarde.`

  const orderText = isSpecialistAnalyst
    ? "Protocolo do seu atendimento:"
    : "Pedido:"

  const textLink = isSpecialistAnalyst
    ? "Acompanhar minhas solicitações"
    : "Ir para a página do cliente"

  const link = isSpecialistAnalyst
    ? "/fixed-voice/specialist-requests"
    : "/fixed-voice"

  const onCopyProtocol = async () => {
    try {
      await navigator.clipboard.writeText(requestId)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 2000)
    } catch (err) {
      console.error("Falha ao copiar id do pedido: ", err)
    }
  }

  return (
    <div className={styles.box}>
      <div className={styles.title_container}>
        <div className={styles.title}>
          <div className={styles.icon}>
            <img src={iconSuccess} alt={"icon success"} />
          </div>
          <Typograph
            htmlTag="h2"
            size="medium"
            color="outer_space"
            weight="bold"
          >
            {receivedOrderText}
          </Typograph>
        </div>
        <div className={styles.title_situation}>
          <Typograph
            htmlTag="span"
            size="extra_small"
            weight="semi_bold"
            color="blue_cola"
          >
            Em andamento
          </Typograph>
        </div>
      </div>

      <div className={styles.separate}>
        <Typograph
          htmlTag="p"
          size="medium"
          weight="regular"
          color="nevada_gray"
          classNames={styles.descriptionClass}
        >
          {description}
        </Typograph>
      </div>

      {infoSuspension && <OrderInfo text={infoSuspensionText} />}

      {!isSpecialistAnalyst && <OrderInfo text={protocolText} />}

      <div className={styles.separate}>
        <div className={styles.protocol}>
          <div className={styles.one_protocol}>
            <Typograph
              htmlTag="p"
              size="medium"
              weight="semi_bold"
              color="charcoal_grey"
            >
              {orderText}
            </Typograph>

            {isCopied ? (
              <Typograph
                htmlTag="span"
                size="medium"
                weight="semi_bold"
                color="nevada_grey"
              >
                Copiado
              </Typograph>
            ) : (
              <div
                className={styles.list_protocol_one}
                onClick={() => onCopyProtocol()}
              >
                <Typograph
                  htmlTag="p"
                  size="medium"
                  weight="regular"
                  color="nevada_grey"
                >
                  {isSpecialistAnalyst ? protocolo : requestId}
                </Typograph>

                <img src={iconCopy} alt={"copy and paste"} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.separate}>
        <div className={styles.breadcrumb}>
          <div className={styles.arrow_right}>
            <img src={iconArrowRight} alt={"right"} />
          </div>
          <Link to={link} callToAction>
            {textLink}
          </Link>
        </div>
      </div>
    </div>
  )
}
OrderStatus.propTypes = {
  infoSuspension: PropTypes.bool,
  category: PropTypes.string,
  quantityOfNumbers: PropTypes.string,
  assigneeName: PropTypes.string,
  isPortability: PropTypes.bool,
  isSpecialistAnalyst: PropTypes.bool,
  requestId: PropTypes.string,
  protocolo: PropTypes.string
}
export default OrderStatus



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ConfirmScreen/OrderStatus.js